import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  FIND_MORE: "Find out more",
  BACK: "Back",
  NEXT: "Next",
  NAVIGATED: COMMON_EVENT_NAMES.NAVIGATED
};
